import React, {Component} from 'react';
import MaterialIcon from '../../MaterialIcon';

export default class ValueTypeSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            selectedType: this.props.types.find((type) => type.xmlType === this.props.selectedType)?.text
        };

        this.onExpandClick = this.onExpandClick.bind(this);
        this.onSelectType = this.onSelectType.bind(this);
    }

    onExpandClick() {
        this.setState(prevState => ({
                expanded: !prevState.expanded
            })
        );
    }

    onSelectType(index) {
        this.setState({selectedType: this.props.types[index].text, expanded: false});
        this.props.onTypeSelect(this.props.types[index].text);
    }

    render() {
        return (
            <div className="type-selector">
                <button onClick={this.onExpandClick}>{this.state.selectedType}
                    {
                        !this.props.disableArea &&
                        <MaterialIcon icon="expand_more"/>
                    }
                </button>
                {this.state.expanded && !this.props.disableArea ?  (
                    <div className="types">
                        {this.props.types && this.props.types.map((type, index) => (
                            <div key={index} className="type" onClick={() => this.onSelectType(index)}>
                                <MaterialIcon icon={type.icon}/>
                                <span className="text">{type.text}</span>
                            </div>
                        ))}
                    </div>
                ) : true}
            </div>
        );
    }
}
